import "./product-attr.scss";
import { Spinner, Modal } from "@wordpress/components";

import React from "react";
import { render, useState, useEffect } from "@wordpress/element";

const App = () => {
	return <button type="button">Open settings</button>;
};

// jQuery(".sasw_attribute_settings").each(function () {
// 	const el = jQuery(this);
// 	render(<App />, el.get(0));
// });
